{
  "nl": {
    "aiChat": {
      "aiAssistant": {
        "explore": {
          "filters": {
            "all": "Hoogtepunten",
            "character": "Persona's",
            "model": "AI-Taalmodellen",
            "plugin": "Plugins",
            "pupils": "Leerlingen",
            "teachers": "Docenten"
          },
          "titles": {
            "administration": "Schoolbeheer en Organisatie",
            "exercises": "Oefeningen en Leerhulpen",
            "featured": "Populaire Assistenten",
            "feedback": "Feedback en Beoordeling",
            "information": "Informatie en Oriëntatie",
            "inspiration": "Inspiratie en Creativiteit",
            "material": "Materiaal en Opdrachten",
            "model": "Plugins",
            "other": "Overige",
            "planning": "Lesplanning en Organisatie",
            "roleplay": "Chatbots voor Rollenspellen"
          }
        },
        "errors": {
          "skillUploadFailed": "Skill kon niet worden geüpload. Probeer het opnieuw.",
          "maxSkillsReached": "Maximaal {max} skills per assistent.",
          "skillInUse": "Deze skill wordt nog door een assistent gebruikt en kan niet worden verwijderd.",
          "saveFailed": "Wijzigingen konden niet worden opgeslagen. Probeer het opnieuw.",
          "skillContentTooLong": "De skill-inhoud overschrijdt de maximale lengte van 100.000 tekens.",
          "skillBundleInvalid": "Het skill-bundel is ongeldig of bevat onveilige bestandspaden.",
          "skillBundleMissingSkill": "Het skill-bundel moet een SKILL.md bevatten in de hoofdmap of in een enkele bovenliggende map.",
          "skillBundleTooLarge": "Het skill-bundel of een bijbehorend bestand overschrijdt de toegestane grootte.",
          "skillBundleTooManyFiles": "Het skill-bundel mag maximaal 200 bestanden bevatten."
        },
        "hints": {
          "fileExtractingText": "Tekst wordt geëxtraheerd...",
          "fileParsingImages": "Afbeeldingen worden verwerkt: {progress}%",
          "fileIndexingFailed": "Bestand kon niet worden geïndexeerd",
          "fileIndexingRunning": "Bestand wordt geïndexeerd",
          "fileIndexingProgress": "Indexering: {progress}%",
          "fileIndexingSuccessfully": "Bestand succesvol geïndexeerd",
          "largeFileUploaded": "De geüploade tekst is erg groot en is geschikt als achtergrondkennis voor concrete vragen over de tekst en reproductietaken (AFB I).",
          "maxHandoffsReached": "Maximaal {max} handoff-assistenten per assistent.",
          "noHandoffAssistants": "Geen passende assistenten gevonden.",
          "noSkills": "Nog geen skills beschikbaar.",
          "skillUploadHint": "Het .md-bestand moet in de YAML-frontmatter de velden name, description en when-to-use bevatten. Optioneel: allowed-tools.",
          "skillBundleUploadHint": "Ondersteunde formaten: Markdown (.md) of een ZIP-skill-bundel (.zip). Een ZIP-bundel moet een SKILL.md bevatten in de hoofdmap of in een enkele bovenliggende map; scripts, referenties en sjablonen zijn optioneel.",
          "skillDocLink": "Meer informatie"
        },
        "infoMessages": {
          "assistantFiles": "Hier kun je extra achtergrondkennis uploaden voor je assistent, waar deze bij een verzoek toegang toe heeft. Houd er rekening mee dat je assistent geen afbeeldingen in PDF's kan lezen.",
          "conversationStarters": "Formuleer een duidelijke opdracht aan het taalmodel om een specifieke taak uit te voeren. Bijvoorbeeld: 'Maak een lesplan voor mij.'",
          "enabledTools": "Met behulp van plugins kan je assistent verschillende tools aanroepen of afbeeldingen genereren.",
          "handoffAssistants": "Selecteer maximaal twee assistenten aan wie deze assistent tijdens een gesprek taken mag delegeren.",
          "skills": "Skills zijn herbruikbare instructiepakketten. Selecteer welke skills deze assistent mag laden met de read_skill-tool.",
          "systemPrompt": "In de instructie kun je de taak voor je assistent formuleren. In de catalogus vind je de AI-assistent Rob, de rollenpromptexpert, die je helpt bij het formuleren."
        },
        "labels": {
          "author": "Auteur",
          "enabledTools": "Plugins",
          "fobizzSkills": "Fobizz Skills",
          "handoffAssistants": "Handoff-Assistenten",
          "manageSkills": "Skills beheren",
          "model": "Model",
          "mySkills": "Mijn Skills",
          "openModels": "Open Modellen",
          "otherModels": "Andere Modellen",
          "recommendedModels": "Aanbevolen Modellen",
          "remixCount": "Remix",
          "searchSkills": "Skills doorzoeken...",
          "skillFileCount": "1 bestand | {count} bestanden",
          "skills": "Skills",
          "systemPrompt": "Rol en Instructies"
        },
        "links": {
          "create": "Assistent aanmaken",
          "copySkill": "Kopiëren naar klembord",
          "downloadSkill": "Skill downloaden",
          "removeSkill": "Skill verwijderen",
          "uploadSkill": "Skill uploaden"
        },
        "buttons": {
          "removeSkill": "Skill verwijderen"
        },
        "paragraphs": {
          "alert": "Of het nu voor jou of je leerlingen is, je eigen assistent is gericht op een specifiek toepassingsgebied. Je kunt bijvoorbeeld documenten zoals afbeeldingen of krantenartikelen uploaden en er gerichte vragen over stellen.",
          "alertPupil": "Je eigen assistent is gericht op een specifiek toepassingsgebied. Je kunt bijvoorbeeld documenten zoals afbeeldingen of krantenartikelen uploaden en er gerichte vragen over stellen."
        },
        "placeholders": {
          "conversationStarter": "Voer een voorgestelde vraag of opdracht in...",
          "description": "Korte uitleg voor gebruikers over wat je assistent kan...",
          "searchHandoffAssistants": "Assistenten zoeken voor handoff...",
          "systemPrompt": "Stel hier precies in hoe je assistent zich in welke situaties moet gedragen, welke plugins en bronnen hij of zij in welke gevallen bij voorkeur gebruikt en welke rol hij of zij in de chat moet aannemen."
        },
        "titles": {
          "alert": "Hier kun je eenvoudig je eigen assistent aanmaken",
          "community": "Ontdek AI-assistenten voor je dagelijkse schoolpraktijk",
          "create": "Maak en deel je eigen assistenten"
        },
        "tooltips": {
          "clickToUploadAvatar": "Klik of sleep een afbeelding hierheen",
          "generateAvatar": "Afbeelding genereren",
          "generateConversationStarter": "Chatstarter-voorstel genereren",
          "generateConversationStarterDisabled": "Vul naam en beschrijving in om een chatstarter te laten genereren",
          "generatePrompt": "Instructie genereren",
          "adminOnly": "Alleen zichtbaar voor beheerders 🤓",
          "generatePromptDisabled": "Vul naam en beschrijving in om een instructie te laten genereren",
          "remixNotAllowed": "Voor deze assistent is de remix niet toegestaan."
        }
      },
      "confirm": {
        "deleteAssistant": {
          "text": "De assistent wordt uit je overzicht verwijderd. Je vindt hem daarna in de prullenbak.",
          "title": "Assistent verwijderen?"
        },
        "deleteChat": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. De chat {modelName} wordt met alle berichten permanent verwijderd.",
          "title": "Chat verwijderen?"
        }
      },
      "conversationGroups": {
        "last30Days": "Laatste 30 dagen",
        "last7Days": "Laatste 7 dagen",
        "older": "Ouder",
        "today": "Vandaag",
        "yesterday": "Gisteren"
      },
      "conversationStartersDefault": {
        "prompt1": "Maak een brainstorm met vijf creatieve ideeën voor een introductie van het onderwerp 'Elektrische weerstand' in natuurkunde voor een 9e klas",
        "prompt2": "Ontwikkel drie open toetsvragen voor de karakteranalyse van 'Der Besuch der alten Dame' voor een Duitse les in de 11e klas van een scholengemeenschap",
        "prompt3": "Schrijf een uitnodiging voor het oudergesprek op 25 september om 18:30 uur.",
        "prompt4": "Maak een tabelvormig lesplan voor een wiskundeles van 90 minuten in de 8e klas over het onderwerp 'Stelling van Pythagoras'."
      },
      "conversationStartersStudents": {
        "prompt1": "Leg me uit hoe ik deze opgave kan oplossen: 'Schrijf een gedichteninterpretatie'",
        "prompt2": "Kun je me uitleggen wat 'mitose' is?",
        "prompt3": "Ik moet een spreekbeurt houden over de Europese Unie. Help me een onderwerp te vinden.",
        "prompt4": "Help me me voor te bereiden op een proefwerk politiek over de 'Brexit'."
      },
      "errors": {
        "conversationCreateFailed": "Fout bij het aanmaken van het gesprek. Probeer het opnieuw.",
        "fileAlreadyExists": "Bestand '{filename}' is al geüpload",
        "fileRemoveFailed": "Fout bij het verwijderen van het bestand",
        "fileUploadFailed": "Fout bij het uploaden van '{filename}'",
        "maxFilesReached": "Maximaal {max} bestanden toegestaan",
        "visionNotSupportedDescription": "Wijzig het model of verwijder de afbeelding.",
        "visionNotSupportedTitle": "Het geselecteerde model ondersteunt geen afbeeldingen"
      },
      "form": {
        "avatar": "Hoe ziet jouw assistent eruit?",
        "fileLimit": "(max. {maxFiles} bestanden, elk max. {size} MB, totaal max. {totalSize} MB)",
        "files": "Heeft jouw assistent speciale achtergrondinformatie?",
        "imageHint": "Maak een AI-gegenereerde voorbeeldafbeelding of {uploadLink}.",
        "knowledge": "Wie is jouw assistent en wat kan hij?",
        "title": "Assistent aanmaken",
        "upload": "Achtergrondkennis uploaden",
        "uploadLinkText": "upload een eigen afbeelding"
      },
      "headers": {
        "editConversation": "Gesprek hernoemen"
      },
      "help": {
        "scrollToBottom": "Naar beneden scrollen",
        "scrollToTop": "Naar boven scrollen",
        "startSpeech": "Antwoord afspelen",
        "stopSpeech": "Afspelen stoppen",
        "switchGoogleAccount": "Google-account wisselen",
        "uploadFileDescription": "Mogelijke formaten: PDF, Word, PowerPoint, Excel, CSV, JSON, XML. Belangrijk: zorg ervoor dat de bestanden geen persoonlijke gegevens bevatten.",
        "uploadGoogleDrive": "Verbind met Google Drive",
        "uploadImageDescription": "Stel vragen over deze afbeelding, laat deze analyseren of tekstinhoud transcriberen. Belangrijk: zorg ervoor dat de afbeeldingen geen persoonlijke gegevens bevatten.",
        "voiceMode": "Interactieve spraakmodus 🤓",
        "voiceRecorder": "Start audio-opname en spreek de prompt in.",
        "documentExport": "Hier vind je nieuwe exportfuncties",
        "exportHint": "Hier vind je nieuwe exportopties, bijvoorbeeld als PDF, PowerPoint of Word-bestand."
      },
      "hints": {
        "cancelled": "Antwoord geannuleerd.",
        "chatPrompt": "Deel nooit persoonlijke gegevens met de AI en controleer de antwoorden kritisch.",
        "chatPromptTooltip": "Meer informatie over actieve gegevensbescherming",
        "emptyConversationPdf": "Deze chatgeschiedenis is leeg.",
        "emptyConversationPdfTitle": "Download AI-Chatgesprek",
        "emptyConversationPdfAlt": "Illustratie van een leeg chatgesprek",
        "fileUpload": "Materiaal toevoegen",
        "fileUploadLimitReached": "Je hebt de uploadlimiet voor bestanden en afbeeldingen bereikt. Verwijder een bestand om een nieuw bestand toe te voegen.",
        "flagged": "Dit bericht is geweigerd vanwege inhoudsfilters. Probeer het opnieuw met een andere prompt.",
        "noSearchResults": "We hebben helaas geen chat met deze term kunnen vinden.",
        "perplexityNote": "De antwoorden van deze AI-chatbot zijn gebaseerd op een webzoekopdracht uitgevoerd door Perplexity. Onthoud dat de resultaten gebaseerd zijn op webinhoud en daarom kritisch moeten worden gecontroleerd. Gebruik de webzoekopdracht om je vragen te stellen en controleer de bronnen zorgvuldig.",
        "remixableHint": "Anderen kunnen jouw assistent kopiëren en als basis gebruiken voor hun eigen assistenten.",
        "selectSystemHint": "Instellingen en Tools"
      },
      "labels": {
        "allCitationsWithCount": "Alle bronnen ({count})",
        "category": "Categorie",
        "conversationStarter": "Chatstarter",
        "conversationStarters": "Chatstarter",
        "createdWithModel": "Gemaakt met {model}",
        "experimental": "Preview",
        "featured": "Nieuw",
        "remixable": "Remix toestaan",
        "fobizzAi": "fobizz AI",
        "imageModel": "Afbeeldingsgenerator",
        "international": "Taal:",
        "maxDailyMessagesCount": "Dagelijkse limiet",
        "model": "Taalmodel",
        "newConversation": "Nieuw gesprek",
        "remixAssistantFiles": "De documenten mogen bij het remixen worden hergebruikt.",
        "removeSystemHint": "Systeemnotitie verwijderen",
        "selectModel": "Taalmodel selecteren",
        "modelSelectionGuide": "Welk taalmodel past bij jouw assistent?",
        "modelSelectionLink": "Naar overzicht",
        "pupilRestrictedModelWarning": "Dit model is alleen beschikbaar voor docenten. Leerlingen gebruiken automatisch een ander standaardmodel.",
        "selectSystemHint": "Kies een systeemnotitie",
        "showAllCitations": "Alle bronnen weergeven",
        "subcategory": "Subcategorie",
        "thinking": "Nadenken",
        "handoff": "Overdracht",
        "viewImage": "Afbeelding bekijken",
        "message": "Bericht van {author}"
      },
      "toolApproval": {
        "approve": "Bevestigen",
        "reject": "Afwijzen",
        "approved": "Bevestigd",
        "rejected": "Afgewezen",
        "error": "De beslissing kon niet worden opgeslagen. Probeer het opnieuw."
      },
      "runActivity": {
        "outcome": {
          "completed": "Voltooid",
          "cancelled": "Geannuleerd",
          "failed": "Fout"
        },
        "status": {
          "running": "Bezig",
          "awaitingApproval": "Wacht op jouw bevestiging",
          "completed": "Voltooid",
          "cancelled": "Geannuleerd",
          "failed": "Mislukt"
        },
        "steps": "1 stap | {count} stappen",
        "step": "Stap {n}",
        "count": "{count}×",
        "stepCancelled": "Geannuleerd",
        "stepFailed": "Deze stap is mislukt.",
        "summary": "{outcome} na {duration}, {steps}",
        "announceStep": "{tool} voltooid",
        "duration": {
          "lessThanSecond": "< 1 s",
          "seconds": "{s} s",
          "minutes": "{m} min.",
          "minutesSeconds": "{m} min. {s} s",
          "hoursMinutes": "{h} uur {m} min."
        },
        "runtimeTools": {
          "search_tools": "Tools vinden",
          "read_tool_result": "Resultaat verder lezen"
        },
        "unknownTool": "Werkstap",
        "waitingForApproval": "Wacht op je bevestiging",
        "handoffTo": "aan {name}"
      },
      "links": {
        "connectGoogleDrive": "Google Drive 🤓",
        "explore": "AI-Assistentencatalogus",
        "helpModelCards": "Beslissingshulp taalmodel",
        "moreModels": "Meer modellen",
        "myAssistants": "Eigen assistenten",
        "removeFile": "Bestand verwijderen",
        "removeMaterial": "Materiaal verwijderen",
        "startChat": "Chat starten",
        "switchGoogleAccount": "Account wisselen",
        "uploadFile": "Bestand uploaden",
        "uploadGoogleDrive": "Bestand selecteren",
        "uploadImage": "Afbeelding uploaden"
      },
      "modelDescriptions": {
        "0": "Selecteert automatisch een passend model voor jouw verzoek",
        "1": "Voor snelle antwoorden en eenvoudige dialogen",
        "2": "Voor meerstaps taken en complexe problemen"
      },
      "placeholders": {
        "promptInputDefault": "Wat kan ik vandaag voor je doen?",
        "assistantDeleted": "De assistent is verwijderd — dit gesprek is alleen-lezen.",
        "searchAssistants": "Waar heb je hulp bij nodig?",
        "searchChats": "Chats doorzoeken...",
        "searchMyAssistants": "Assistenten doorzoeken..."
      },
      "privacyProtectionModal": {
        "description": "Jouw invoer en gesprekken zijn privé, worden door fobizz geanonimiseerd en niet gebruikt voor het trainen van AI-modellen.",
        "learnMore": "Meer informatie",
        "learnMoreUrl": "https://app.fobizz.com/de/help/categories/63-datenschutz-recht",
        "title": "Actieve gegevensbescherming"
      },
      "promptLibraryModal": {
        "description": "Onze promptcollectie bevat veel nuttige ideeën. Kies een prompt en vul deze aan met je eigen informatie.",
        "header": "Promptbibliotheek",
        "submitPromptHtml": "Eigen promptvoorstel indienen: <a href=\"https://app.fobizz.com/surveys/surveys/f7d293df-e9d9-4fdf-b47c-df0d79221942/public_survey_responses/new?token=ed4073db9ac22c8bcbcc65727711eb0e\"  target=\"_blank\">Naar het formulier</a>"
      },
      "studentPromptLibrary": {
        "examPrep": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Examen voorbereiding"
        },
        "jobApplication": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Sollicitatietraining"
        },
        "learningAssistance": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Hulp bij het leren"
        },
        "writingAssistance": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Hulp bij het schrijven"
        }
      },
      "success": {
        "fileRemoved": "'{filename}' succesvol verwijderd",
        "fileUploaded": "'{filename}' succesvol geüpload",
        "skillCopied": "Skill gekopieerd naar klembord",
        "skillRemoved": "Skill succesvol verwijderd"
      },
      "systemPrompt": "Je bent een behulpzame en vriendelijke assistent. Als je een antwoord niet weet, zeg dan: \"Ik weet het niet.\" Vraag door als je meer informatie nodig hebt om mijn verzoek goed te beantwoorden. Antwoord altijd in de taal waarin je wordt aangesproken.",
      "systemPromptLibrary": {
        "careerCounseling": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Beroepsoriëntatie"
        },
        "experts": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Expert*"
        },
        "languageAndWritingCoaches": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Schrijf- en taalhulp"
        }
      },
      "systemPromptModal": {
        "editLabel": "Rolomschrijving bewerken",
        "heading": "AI-Chat rol aanpassen",
        "useSystemPromptLibrary": "of kies uit rollencollectie"
      },
      "takeNote": {
        "bullet1": "Soms geef ik antwoorden die weliswaar aannemelijk klinken, maar inhoudelijk onjuist of verzonnen zijn.",
        "bullet2": "Mijn kennis reikt slechts tot 2023 - van alles wat daarna is gebeurd, heb ik (nog) geen idee.",
        "heading": "Om rekening mee te houden"
      },
      "teaserItem": {
        "linkName": "Ontdek trainingen",
        "title": "Wil je meer leren over AI-assistenten?",
        "url": "https://app.fobizz.com/fortbildungen?search%5Bquery%5D=KI-Assistenten"
      },
      "teaserItem2": {
        "linkName": "Idee indienen",
        "title": "Heb jij een assistent die hier zou moeten verschijnen?",
        "url": "https://app.fobizz.com/surveys/surveys/fa37a4ba-38ba-4ef2-9c99-022e9e551492/public_survey_responses/new?token=4ed09ebc3b212a3886fd53193eee4746"
      },
      "teaserItem3": {
        "linkName": "Meer informatie in de help-sectie",
        "title": "Heb je ondersteuning nodig bij het kiezen van een model?",
        "url": "https://app.fobizz.com/de/help/articles/426-wahl-des-sprachmodells"
      },
      "tips": {
        "bullet1": "Mijn antwoorden zijn uitstekend als eerste opzet, maar zelden als eindresultaat.",
        "bullet2": "Als je niet tevreden bent met mijn antwoord, formuleer het dan nogmaals concreter.",
        "heading": "Tips voor jou"
      }
    }
  }
}
